export default "__VITE_ASSET__D36x9J_J__"